import React, { useState, useEffect, useCallback } from "react";
import { FaSearch } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { ButtonGroup, Button, Form, Row, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import _ from "lodash";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import ButtonImagePermission from "../../../components/UI/Button/ButtonImagePermission";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import constants from "../../Constants";

const CarregandoView = (
  <span>
    <Spinner animation="border" role="status" /> Carregando ...
  </span>
);

const removeCell = (row, setShowDesassociarConfirm) => (
  <ButtonImagePermission
    permission={funcionalidades.tipoDivergencia.deletar}
    className="btn-lg text-danger pa-0 p-0"
    onClick={() =>
      setShowDesassociarConfirm({
        show: true,
        body: `Deseja remover a crítica de código Nº ${row.codObrigacao}?`,
        context: row.codObrigacao,
      })
    }
    buttonImage={<MdClose />}
    tooltipImage="Remover Crítica"
  />
);

const ListaCriticas = ({ field, formik, history, toggledClearRows }) => {
  const [rows, setRows] = useState([]);
  const [criticasRelacionadas, setCriticasRelacionadas] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [inputSearchArgument, setInputSearchArgument] = useState("");
  const [searchParameters, setSearchParameters] = useState({});

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showDesassociarConfirm, setShowDesassociarConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  const updateFormik = (state) => {
    formik.setFieldValue(field, state.selectedRows);
  };

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback(() => {
    setPageSize(25);
    setPageNumber(1);
  }, []);

  const columnsRelacionadas = [
    {
      name: "Ações",
      selector: "",
      maxWidth: "15px",
      center: true,
      cell: (row) => removeCell(row, setShowDesassociarConfirm, formik.values.codObrigacao),
    },
    {
      name: "Cód. Crítica",
      selector: "codObrigacao",
      width: "200px",
      center: true,
      sortable: true,
    },
    {
      name: "Descrição",
      selector: "nomObrigacao",
      sortable: true,
      maxWidth: "1000px",
    },
  ];

  const columnsNaoRelacionadas = [
    {
      name: "Cód. Crítica",
      selector: "codObrigacao",
      width: "200px",
      center: true,
      sortable: true,
    },
    {
      name: "Descrição",
      selector: "nomObrigacao",
      sortable: true,
      maxWidth: "1000px",
    },
  ];

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      toast.success("Ocorrência desassociada com sucesso.");
      document.location.reload(true);
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
    }

    setShowDesassociarConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, setShowDesassociarConfirm, history]);

  const {
    request: requestConsultaCriticas,
    data: dataConsultaCriticas,
    errors: errorConsultaCriticas,
    isLoading: isLoadingCriticas,
  } = useApiClient();

  useEffect(() => {
    requestConsultaCriticas(apiRoutes.fiscalizacao.parametrizacao.consultaTodasCriticasTipoDivergencia, {
      ...searchParameters,
      pageSize,
      pageNumber,
    });
  }, [requestConsultaCriticas, searchParameters, pageSize, pageNumber]);

  useEffect(() => {
    if (dataConsultaCriticas && dataConsultaCriticas.result) {
      setRows(
        dataConsultaCriticas.result.filter(
          (row) => row.sqTipoAutomacao !== formik.values.sqTipoAutomacao && !row.sqTipoAutomacao,
        ) || [],
      );
      setTotalRows(
        dataConsultaCriticas.result.filter(
          (row) => row.sqTipoAutomacao !== formik.values.sqTipoAutomacao && !row.sqTipoAutomacao,
        ).length
          ? dataConsultaCriticas.result[0].length
          : 0,
      );
    }

    if (errorConsultaCriticas) {
      toast.error(errorConsultaCriticas.message);
    }
  }, [dataConsultaCriticas, errorConsultaCriticas, formik.values.sqTipoAutomacao]);

  const { request, data, isLoading } = useApiClient();

  useEffect(() => {
    const params = formik.values.sqTipoAutomacao;
    request(apiRoutes.fiscalizacao.parametrizacao.consultaCriticasTipoDivergencia, { SqTipoAutomacao: params });
  }, [request, formik.values.sqTipoAutomacao]);

  useEffect(() => {
    if (data) {
      setCriticasRelacionadas(data.result);
    }
  }, [data]);

  return (
    <>
      <EfisModal
        show={showDesassociarConfirm.show}
        body={showDesassociarConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowDesassociarConfirm({ show: false })}
        confirmationHandler={() => {
          const params = { codObrigacao: showDesassociarConfirm.context };
          deleteItemRequest(apiRoutes.fiscalizacao.parametrizacao.desassociarCriticaTipoDivergencia, params);
        }}
      />
      {formik.values.sqTipoAutomacao ? (
        <div className="row">
          <div className="col-lg-12">
            <div className="card shadow mb-4">
              <div className="card-header pt-3 pb-0 flex-row w-100">
                <h6 className="m-0 font-weight-bold text-primary flex-grow-1 py-3">Críticas Relacionadas</h6>
              </div>

              <div className="card-body">
                <DataTable
                  noHeader
                  title="Ocorrências não relacionadas"
                  keyField="id"
                  columns={columnsRelacionadas}
                  data={criticasRelacionadas}
                  progressPending={isLoading}
                  noDataComponent="Nenhum registro para exibir"
                  progressComponent={CarregandoView}
                  defaultSortFieldId={1}
                  sortIcon={<BsArrowDown />}
                  pagination
                  sortable
                  onSelectedRowsChange={(state) => updateFormik(state)}
                  pointerOnHover
                  paginationComponentOptions={constants.paginationComponentOptions}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header pt-3 pb-0 flex-row w-100">
              <Form.Group as={Row} className="d-flex flex-row">
                <h6 className="font-weight-bold text-primary flex-grow-1 ml-2 mt-2">Críticas Não Relacionadas</h6>

                <ButtonGroup>
                  <Form.Control
                    className="w-auto border-top-right-0 border-bottom-right-0"
                    type="text"
                    placeholder="Descrição"
                    value={inputSearchArgument}
                    onChange={(e) => setInputSearchArgument(e.target.value)}
                  />

                  <Button
                    className="btn-search-inside btn-md mr-3"
                    onClick={() => {
                      setPageNumber(1);
                      setSearchParameters({ searchArgument: inputSearchArgument });
                    }}
                  >
                    <FaSearch />
                  </Button>
                </ButtonGroup>
              </Form.Group>

              <Form.Label className="small">
                Total selecionado: {formik.values[field] ? formik.values[field].length : 0}
              </Form.Label>
              <br />
              <Form.Label className="text-danger small">{formik.errors[field] ? formik.errors[field] : ""}</Form.Label>
            </div>

            <div className="card-body">
              <DataTable
                noHeader
                title="Críticas não relacionadas"
                keyField="id"
                columns={columnsNaoRelacionadas}
                data={rows}
                progressPending={isLoadingCriticas}
                noDataComponent="Nenhum registro para exibir"
                progressComponent={CarregandoView}
                defaultSortFieldId={1}
                sortIcon={<BsArrowDown />}
                pagination
                sortable
                selectableRows
                selectableRowSelected={(row) =>
                  !!_.find(formik.values[field], (item) => item.codObrigacao === row.codObrigacao)
                }
                onSelectedRowsChange={(state) => updateFormik(state)}
                pointerOnHover
                paginationComponentOptions={constants.paginationComponentOptions}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationTotalRows={totalRows}
                paginationPerPage={25}
                clearSelectedRows={toggledClearRows}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListaCriticas;
